
export const fetchObjectData = (args)=>{
	const method = "GET";
	const headers = new Headers();
	const url = args.url;

	headers.append('Accept', 'application/json');

	let options = {
		headers,
		method
	};

	return fetch(url, options)
		.then( response=>{
//console.log("response : " , response );
			if(response.ok) {
				return response.json();
			}
		})
		.then( json=>{
			return json;
		})
		.catch( error=>{
//console.log("error : " , error);
			throw error;
		})
	;

}



// WEBPACK FOOTER //
// ./src/js/api/objectData.js